import React from 'react';
import locationIcon from "../assets/location.png";
import { IoBedOutline } from "react-icons/io5";
import { MdBathtub, MdOutlineWidthWide } from "react-icons/md";
import './CSS/PropertyCardfull.css';

const PropertyCardfull = ({
  price,
  name,
  location,
  bedrooms,
  bathrooms,
  size,
  images
}) => {
  const firstImage =
    Array.isArray(images) && images.length > 0
      ? images[0]
      : null;
  const formatPrice = (value) =>
      new Intl.NumberFormat('en-AE', {
        style: 'currency',
        currency: 'AED',
        minimumFractionDigits: 0,
      }).format(value);
  return (
    <div className="property-card-full">
      <div className="left-info">
        <h3 className="property-name">{name}</h3>

        <div className="location-row">
          <img src={locationIcon} alt="location" className="location-icon" />
          <span>{location}</span>
        </div>

        <div className="details-row">
          <span className="detail">{formatPrice(price)}</span>
          <span className="detail"><IoBedOutline /> {bedrooms}</span>
          <span className="detail"><MdBathtub /> {bathrooms}</span>
          <span className="detail"><MdOutlineWidthWide /> {size} sqft</span>
        </div>
      </div>

      <div className="right-image">
        {firstImage && (
          <img
            src={firstImage}
            alt="Property"
            className="property-thumb"
          />
        )}
      </div>
    </div>
  );
};

export default PropertyCardfull;
